// extracted by mini-css-extract-plugin
export default {"container":"TW-z","title":"UW-z","link":"VW-z"};